module.exports = __webpack_public_path__ + "img/golden_halloween.ea33ec02.jpg";